<template>
    <div class="cc-consents">
        <dm-heureka-consent />
        <overeno-consent/>
        <dm-glami-consent/>
        <dm-zbozi-consent/>
        <dm-heureka-v2/>
        <newsletter-registration/>
        <recyclable/>
        <gift-wrapping/>
        <shaim-overeno-consent/>
        <pd-ceneo-zaufane-opinie-pro/>
        <shaim-zbozi-cz/>
        <mergado/>
        <terms-of-service/>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import DmHeurekaConsent from "@/components/_common/modules/dm_heureka/DmHeurekaConsent";
    import OverenoConsent from "@/components/_common/modules/overeno/OverenoConsent";
    import TermsOfService from "../_common/TermsOfService/TermsOfService";
    import Recyclable from "@/components/_common/Recyclable/Recyclable";
    import GiftWrapping from "@/components/_common/GiftWrapping/GiftWrapping";
    import DmGlamiConsent from "@/components/_common/modules/dm_glami/DmGlamiConsent";
    import DmZboziConsent from "@/components/_common/modules/dm_zbozi/DmZboziConsent";
    import ShaimOverenoConsent from "../_common/modules/shaim_aio/ShaimOverenoConsent";
    import PdCeneoZaufaneOpiniePro from "../_common/modules/pdceneozaufaneopiniepro/PdCeneoZaufaneOpiniePro";
    import NewsletterRegistration from "../_common/NewsletterRegistration/NewsletterRegistration";
    import ShaimZboziCz from "@/components/_common/modules/shaim_zbozi_cz/ShaimZboziCz";
    import Mergado from "@/components/_common/modules/mergado/Mergado";
    import DmHeurekaV2 from "@/components/_common/modules/dm_heureka_v2/DmHeurekaV2.vue";

    export default {
        components: {
          DmHeurekaV2,
          Mergado,
          ShaimZboziCz,
          NewsletterRegistration,
          PdCeneoZaufaneOpiniePro,
          ShaimOverenoConsent,
          DmGlamiConsent,
          DmZboziConsent,
          GiftWrapping,
          Recyclable,
          TermsOfService,
          DmHeurekaConsent,
          OverenoConsent
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                consents: state => state.consents,
                config: state => state.config,
            }),
        },
    };
</script>

<style lang="scss">
.form-check {
  .form-check-label {
    text-align: left;
  }
  .form-check-input {
    margin-left: 0 !important;
  }
}
</style>
<style lang="scss" scoped="scoped">
    @import "./scss/components/consents";
</style>
